
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.746","height":"26.746","viewBox":"0 0 26.746 26.746"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('circle',{attrs:{"cx":"13.373","cy":"13.373","fill":"#ebb111","r":"13.373"}}),_c('path',{staticClass:"b",attrs:{"d":"M13.163 15.495h-.425a1.37 1.37 0 01-1.275-1.273V7.854a1.37 1.37 0 011.274-1.274h.426a1.37 1.37 0 011.274 1.274v6.368c-.215.636-.639 1.273-1.274 1.273zM13.163 20.59h-.425a1.37 1.37 0 01-1.275-1.274v-.637a1.37 1.37 0 011.274-1.273h.426a1.37 1.37 0 011.274 1.274v.637c-.215.636-.639 1.273-1.274 1.273z"}})])])
          )
        }
      }
    